import React from 'react';
import { Link } from 'react-router-dom';
import Auth from './auth';
import firebase from 'firebase';
import logo from '../assets/img/logo.png'
import { FirebaseAuth } from 'react-firebaseui';

class Signup extends React.Component {

	render() {
		return <section className="home">

			<header>
			<h1>The Village</h1>
			</header>

			<main>

				<div className="header-title">
					<h2>
						<span>T</span>
						<span>h</span>
						<span>e</span>
						<br/>
						<span>V</span>
						<span>i</span>
						<span>l</span>
						<span>l</span>
						<span><span>v</span></span>
						<span>g</span>
						<span>e</span>
					</h2>
				</div>

				<div className="actions ridged">
					<Link to={`/signup/email`} className="button -secondary -huge -icon -email">
					Join With Email
					</Link>

					{/* Facebook Auth through FirebaseAuthUI Flow */}
					<FirebaseAuth uiConfig={Auth} firebaseAuth={firebase.auth()}/>
				</div>

				<div className="card -plain" data-side="powered by">
					<img src={logo} alt="compassion logo"/>
				</div>

			</main>

		</section>

		;
	}
}

export default Signup



// WEBPACK FOOTER //
// ./src/components/signup.js